import { Button, styled } from '@mui/material';

const StyledButton = styled(Button)({
  position: 'relative',
});

export default StyledButton;
